module.exports = __webpack_public_path__ + "static/img/freshman-python.4517268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-python.png
// module id = EI6j
// module chunks = 1